import { render, staticRenderFns } from "./login-input.vue?vue&type=template&id=f488199a&scoped=true&"
import script from "./login-input.vue?vue&type=script&lang=js&"
export * from "./login-input.vue?vue&type=script&lang=js&"
import style0 from "./login-input.vue?vue&type=style&index=0&id=f488199a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f488199a",
  null
  
)

export default component.exports